import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../tooltip/tooltip-component';
import {
  PopupMenuContainer,
  PopupMenuItem,
  PopupMenuItemsContainer,
} from './pop-up-menu-component-style';

/**
 * PopupMenu component.
 * @param {boolean} isOpen - Flag indicating whether the menu is open.
 * @returns {JSX.Element} PopupMenu component.
 */
const PopupMenu = ({
  isOpen,
  onClose,
  menuItems,
  absolute,
  top,
  left,
  right,
  bottom,
}) => {
  const renderPopupMenuItem = (item, index) => (
    <PopupMenuItem
      key={`item ${index + 1}`}
      $disabled={item?.disabled}
      data-popup-menu-item
      role="menuitem"
      className="popup-menu-item"
      onClick={(e) => {
        e.stopPropagation();
        if (!item?.disabled) {
          item.action();
          onClose();
        }
      }}
    >
      {item?.icon}
      {item?.label}
    </PopupMenuItem>
  );

  if (!isOpen) return null;

  return (
    <PopupMenuContainer
      $absolute={absolute}
      $top={top}
      $left={left}
      $right={right}
      $bottom={bottom}
    >
      <PopupMenuItemsContainer
        $absolute={absolute}
        $top={top}
        $left={left}
        $right={right}
        $bottom={bottom}
      >
        {menuItems?.map((item, index) => {
          const itemId = `popup-menu-item-${item?.key}`;

          return item?.tooltip && item?.disabled ? (
            <Tooltip
              key={item?.key}
              id={itemId}
              text={item.tooltip}
              icon={renderPopupMenuItem(item, index)}
            />
          ) : (
            renderPopupMenuItem(item, index)
          );
        })}
      </PopupMenuItemsContainer>
    </PopupMenuContainer>
  );
};

PopupMenu.defaultProps = {
  absolute: false,
  top: 'unset',
  left: 'unset',
  right: 'unset',
  bottom: 'unset',
};

PopupMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  absolute: PropTypes.bool,
  top: PropTypes.string,
  left: PropTypes.string,
  right: PropTypes.string,
  bottom: PropTypes.string,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node.isRequired,
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
      tooltip: PropTypes.string,
      key: PropTypes.string, // if tooltip key is required.
    }).isRequired,
  ).isRequired,
};

export default PopupMenu;
